import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=f23bb9f4&"
import script from "./CardComponent.vue?vue&type=script&lang=ts&"
export * from "./CardComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports